import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classNames from "classnames";
import React from "react";
export var ContentBox = function(param) {
    var title = param.title, children = param.children, className = param.className, headerSMCol = param.headerSMCol, headerRight = param.headerRight;
    return /*#__PURE__*/ _jsxs("section", {
        className: "bg-default rounded md:shadow md:rounded-lg overflow-hidden",
        children: [
            /*#__PURE__*/ _jsxs("header", {
                className: classNames("relative flex md:flex-row justify-between md:border-b-2 border-brandPrimary p-4 pb-2 md:p-8 md:pb-6", {
                    "items-center": !headerSMCol,
                    "flex-row": !headerSMCol,
                    "flex-col": headerSMCol
                }),
                children: [
                    /*#__PURE__*/ _jsx("h2", {
                        className: "text-mdx font-bold",
                        children: title
                    }),
                    headerRight && /*#__PURE__*/ _jsx("div", {
                        className: "md:absolute top-0 right-6 md:right-8",
                        children: headerRight
                    })
                ]
            }),
            /*#__PURE__*/ _jsx("div", {
                className: classNames("p-3 pt-2 md:p-8 md:pt-6", className),
                children: children
            })
        ]
    });
};
